export const OK = async() => undefined;

const NOOP = Function.prototype;

/**
 * A self controlling timeout on function call
 *
 * If `condition` if fulfiled and `delay` time has passed, calls `f`.
 *
 * @param {Function} f - Function to call when delay has passed
 */
export default (f, delay = 1000, condition = OK, { onCancel = NOOP, onReject = NOOP } = {}) => {
  const holder = { timer: null, fun: Function.prototype };

  return (function(...args) {
    clearTimeout(this.timer);
    this.fun = f.bind(undefined, ...args);

    this.timer !== null && onCancel(this.timer, this.fun);

    return new Promise(
      res => this.timer = setTimeout(() => res(condition().then(this.fun).catch(onReject)), delay)
    );
  }).bind(holder);
};
